const userSelectedChatModel = "nama_selected_chat_model"

export function getAISelectedModel() {
  return localStorage.getItem(userSelectedChatModel) || ''
}

export function setAISelectedModel(model: string) {
  localStorage.setItem(userSelectedChatModel, model)
}
